// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container img{
    width: 90px;
    height: 90px;
    object-fit: cover;
    border-radius: 50%;
}


.profile-container {
      width: 93px;
    height: 93px;
    border: 2px solid rgba(254, 160, 246, 1);
    border-radius: 50%;
    box-shadow: 0 0  10px rgba(254, 160, 246, 1);
}

.Grade span{
    font-size: 14px;
}

`, "",{"version":3,"sources":["webpack://./src/styles/profile.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;MACM,WAAW;IACb,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".profile-container img{\n    width: 90px;\n    height: 90px;\n    object-fit: cover;\n    border-radius: 50%;\n}\n\n\n.profile-container {\n      width: 93px;\n    height: 93px;\n    border: 2px solid rgba(254, 160, 246, 1);\n    border-radius: 50%;\n    box-shadow: 0 0  10px rgba(254, 160, 246, 1);\n}\n\n.Grade span{\n    font-size: 14px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
